import { put, call, delay, fork } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { setSnackbarErrorAction } from '../actions/snackbarActions'
import * as api from '../api'
import { getErrorMessage } from '../domain/Errno'
import { writeGuestInfo } from '../libs/auth'
import { to886 } from '../libs/utils'

export function* sendSMSSaga({ payload: mobile }) {
  try {
    yield put({ type: types.FETCHING })
    // TODO [future] convert 09xx to +8869xx; other country?
    const convertedMobile = to886(mobile)

    yield call(api.requestSendSMS, { mobile: convertedMobile })

    yield put({
      type: types.SEND_SMS_SUCCESS,
      payload: mobile,
    })
    yield fork(lockSendSMSSaga, 60000)
  } catch (err) {
    if (err.status === 409) {
      yield put({
        type: types.SMS_REDIRECT_TO_LOGIN,
        payload: mobile,
      })
    } else if (
      err.status === 429 &&
      err.data?.errno === 'ERR_AIFIAN_MEMBER_SERVICE_AUTH_CODE_ACQUIRED'
    ) {
      // 短時間內不得再發送簡訊驗證碼
      yield put({ type: types.SEND_SMS_ERROR })
      yield put(setSnackbarErrorAction('目前不能發送簡訊，請稍後再試'))
    } else {
      console.error('sendSMSSaga', err)
      const message = getErrorMessage(err)
      yield put({ type: types.SEND_SMS_ERROR })
      yield put(setSnackbarErrorAction(message))
    }
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* confirmSMSSaga({ payload }) {
  try {
    yield put({ type: types.FETCHING })
    const { mobile } = payload
    payload.mobile = to886(mobile)
    const { data } = yield call(api.requestConfirmSMS, payload)
    writeGuestInfo(data.member_id, mobile)
    yield put({
      type: types.CONFIRM_SMS_SUCCESS,
      payload: data,
    })
  } catch (err) {
    if (err.status === 409) {
      yield put({
        type: types.SMS_REDIRECT_TO_LOGIN,
        payload: payload.mobile,
      })
    } else {
      console.error('confirmSMSSaga', err)
      yield put({ type: types.CONFIRM_SMS_ERROR })
      // const message = getErrorMessage(err)
      // yield put(setSnackbarErrorAction(message))
    }
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

function* lockSendSMSSaga(ms) {
  yield put({
    type: types.LOCK_SEND_SMS,
    payload: true,
  })
  yield delay(ms)
  yield put({
    type: types.LOCK_SEND_SMS,
    payload: false,
  })
}
